import React from "react";
import { faBadgeCheck, faMinusCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row, ProgressBar } from "react-bootstrap";
import { get } from "lodash";
import AddToolTip from "../AddToolTip";
import { usCurrency, usDateFormat } from "../../utils";
import payrollFrequency from "./../../mocks/payrollFrequency.json";
import { LOAN_STATUS } from "../../utils";
import LoanEmployeeDetails from "./LoanEmployeeDetails";

const LoanSummaryCard = ({
  loanData,
  planData,
  loanSettingInfo,
  employeeInfo,
  principalPaid,
  calculateTotalNoOfInstallments,
}) => {
  const progression = Math.round(
    (principalPaid / loanData.requestedAmount) * 100
  );

  const loanStatuses = (status) => {
    switch (status) {
      case "AwaitingApproval":
        return {
          icon: null,
          color: "awaiting-approval-status",
          status: status,
        };
      case "Active":
        return { icon: faBadgeCheck, color: "active-status", status: status };
      case "RefinancingRequestAwaitingApproval":
        return { icon: faBadgeCheck, color: "active-status", status: "Active" };
      case "ReAmortizationRequestAwaitingApproval":
        return { icon: faBadgeCheck, color: "active-status", status: "Active" };
      case "Suspended":
        return {
          icon: faMinusCircle,
          color: "suspended-status",
          status: status,
        };
      default:
        return { icon: null, color: "", status: status };
    }
  };

  return (
    <div className="loan-summary-card-container">
      <Row>
        <Col md={3} className="loan-summary-card-bg-color">
          <LoanEmployeeDetails employeeInfo={employeeInfo} />
          <div className="loan-border-bottom mt-1  mb-1" />
          <div className="ft-12 card-text-color mb-1">Plan Details</div>
          <p className="ft-14 fw-500 mb-1">
            <AddToolTip name={loanData?.planName ?? planData?.planName} />
          </p>
          <p className="ft-12 card-text-color mb-1">
            {loanData?.rkPlanNumber ?? planData?.rkPlanNumber}
          </p>

          {/* <p className="ft-12 card-text-color m-0 mb-1">
            <span className="text-black">06</span> /{" "}
            {Math.round(
              calculateTotalNoOfInstallments(
                "Monthly",
                loanData.tenureYears,
                loanData.tenureMonths
              )
            )}{" "}
            Installments Paid
          </p> */}
        </Col>
        {console.log("nandhu", loanData)}
        <Col md={9} className="pd-15">
          <p className="ft-14 fw-500 mb-1">{loanData.loanType ?? "-"}</p>
          <div className="d-flex w-100">
            <div className="w-25 mr-3">
              <div className="d-flex justify-content-start">
                <p className="ft-12 card-text-color mb-1 mr-2">Loan ID</p>
                <p className="ft-12 fw-500 mb-1">
                  {loanData.loanIdentifier ?? "-"}
                </p>
              </div>

              <span>
                <div className="loan-progress-bar">
                  <ProgressBar now={progression} />
                </div>
              </span>
              <p className="d-flex justify-content-between ft-12 card-text-color m-0 mb-1">
                <p className="mb-1 mt-1">
                  Paid{" "}
                  <span className="text-black">
                    {usCurrency(principalPaid ?? 0)}
                  </span>{" "}
                  / {usCurrency(loanData.requestedAmount)}
                </p>
                <p className="text-black mb-1 mt-1">{progression}%</p>
              </p>
            </div>
            <div className="w-25 mr-3">
              <div className="ft-12 card-text-color mb-1">
                Outstanding Loan Balance
              </div>
              <div className="ft-14 fw-500 mb-1">
                {usCurrency(loanData.outstandingBalance ?? 0)}
              </div>
            </div>
            <div className="w-25 mr-3">
              <div className="ft-12 card-text-color mb-1">Loan Tenure</div>
              <div className="ft-14 fw-500 mb-1">
                {loanData.tenureYears} years {loanData.tenureMonths} months
              </div>
              {/* <div className="ft-12 card-text-color mb-1">
                (02/08/2022 to 09/10/2024)
              </div> */}
            </div>
            <div className="d-flex w-25 flex-column mr-3">
              <div className="ft-12 card-text-color mb-1">Loan status</div>
              <div className="d-flex flex-row">
                <FontAwesomeIcon
                  icon={loanStatuses(LOAN_STATUS[loanData.loanStatus]).icon}
                  style={{ marginTop: "2px", marginRight: "2px" }}
                  className={`${
                    loanStatuses(LOAN_STATUS[loanData.loanStatus]).color
                  } ft-14`}
                />
                <span
                  className={`${
                    loanStatuses(LOAN_STATUS[loanData.loanStatus]).color
                  } ft-12 fw-600 mb-1`}
                >
                  {loanStatuses(LOAN_STATUS[loanData.loanStatus]).status ?? "-"}
                </span>
              </div>
            </div>
          </div>

          <div className="loan-dashed-border-bottom" />

          <div className="d-flex w-100 mt-3">
            <div className="w-25">
              <div className="ft-12 card-text-color mb-1">Reason for loan</div>
              <div className="ft-14 fw-500 mb-1">
                <AddToolTip
                  name={loanData?.reasonForLoan ?? loanData?.loanReason}
                />
              </div>
            </div>
            <div className="w-25">
              <div className="ft-12 card-text-color mb-1">Interest Rate</div>
              <div className="ft-14 fw-500 mb-1">
                {loanData.interestRate.toFixed(2)}%
              </div>
            </div>
            <div className="w-25">
              <div className="ft-12 card-text-color mb-1">Periodic Payment</div>
              <div className="ft-14 fw-500 mb-1">
                {loanData?.periodicPaymentAmount != undefined
                  ? usCurrency(loanData?.periodicPaymentAmount)
                  : usCurrency(loanData?.periodicPayment)}
                /{" "}
                <span className="card-text-color">
                  {payrollFrequency.data
                    .find(
                      (_) =>
                        _.value == get(loanData, "repaymentFrequency", null)
                    )
                    ?.label.replace("-", "")}
                </span>
              </div>
            </div>
            <div className="w-25">
              <div className="ft-12 card-text-color mb-1">
                First Repayment Date
              </div>
              <div className="ft-14 fw-500 mb-1">
                {usDateFormat(loanData.firstRepaymentDate)}
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LoanSummaryCard;
